import {
    Server,
    Cloud,
    Sparkles,
    AppWindow,
    BookOpen,
    ArrowUpRight,
} from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { buildAreas } from "../../data/portfolioData";

const ICONS = { Server, Cloud, Sparkles, AppWindow, BookOpen };

const Card = ({ area, large }) => {
    const Icon = ICONS[area.icon] || Server;
    return (
        <div
            data-testid={`build-area-${area.id}`}
            className={`group relative overflow-hidden rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-ink-cyan/30 hover:shadow-lg hover:shadow-black/40 md:p-8 ${
                large ? "md:col-span-3" : "md:col-span-2"
            }`}
        >
            <div className="pointer-events-none absolute inset-0 bg-line-grid opacity-0 transition-opacity duration-500 group-hover:opacity-30" />

            <div className="relative flex h-full flex-col">
                <div className="mb-6 flex items-center justify-between">
                    <div className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface-muted)] text-ink-cyan">
                        <Icon className="h-5 w-5" />
                    </div>
                    <ArrowUpRight className="h-4 w-4 text-[var(--ink-text-secondary)] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink-cyan" />
                </div>

                <h3 className="text-lg font-medium text-[var(--ink-text-primary)] md:text-xl">
                    {area.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[var(--ink-text-secondary)]">
                    {area.description}
                </p>

                <div className="mt-6 flex flex-wrap gap-2">
                    {area.tags.map((t) => (
                        <span
                            key={t}
                            className="rounded-md border border-[var(--ink-border)] bg-[var(--ink-bg)] px-2 py-1 font-mono text-[11px] text-[var(--ink-text-secondary)]"
                        >
                            {t}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export const BuildAreasSection = () => {
    return (
        <section
            id="build"
            data-testid="build-areas-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="02"
                    kicker="Things I build"
                    title="From APIs that quietly run, to stories about weird tech."
                    subtitle="Five rough categories my work usually falls into."
                />

                <div className="grid grid-cols-1 gap-6 md:grid-cols-6 md:gap-8">
                    {/* top row: 2 wide cards */}
                    <Card area={buildAreas[0]} large />
                    <Card area={buildAreas[1]} large />
                    {/* bottom row: 3 cards */}
                    <Card area={buildAreas[2]} />
                    <Card area={buildAreas[3]} />
                    <Card area={buildAreas[4]} />
                </div>
            </div>
        </section>
    );
};

export default BuildAreasSection;
